import { Navigate } from 'react-router-dom';
import { TermsServiceGoogle } from '.';
const routes = [
    {
        path: '/terms-of-service',
        element: <TermsServiceGoogle />,
        title: 'Terms of Service'
    }
]

export default routes;